import {globalCatch} from "../../../_services/global-catch";
import {SET_ACADEMIC_SECTIONS, SET_ACADEMIC_SECTION} from "./constants";
import {svcAcademicSection} from "../../../_services/academic-section-service";

export const setAcademicSections = payload => ({type: SET_ACADEMIC_SECTIONS, payload});

export const fetchAcademicSections = () => globalCatch.catch(async (dispatch) => {
    const academicSections = await svcAcademicSection().getAllAcademicSections()
    dispatch(setAcademicSections(academicSections));
});

export const setAcademicSection = payload => ({type: SET_ACADEMIC_SECTION, payload});

export const fetchAcademicSection = id => globalCatch.catch(async (dispatch) => {
    const academicSection = await svcAcademicSection().getAcademicSection(id)
    dispatch(setAcademicSection(academicSection));
});
